import { useContext, useState, useCallback, useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import "App.scss"
import { CardColumn } from "components/CardColumn"
import { BigButton } from "components"
import { Footer } from "components/Footer"
import { useNavigator } from "hooks/useNavigator"

import { useTranslation } from "react-i18next"
import i18n from "helpers/i18n"
import { CartContext } from "App"
import { Box } from "@mui/material"
import { NavHighlightedMenu } from "components/NavHighlightedMenu"
import { useScrollPositionSaver } from "hooks/useScrollPositionSaver"

const gridContainerStyle = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: "20px",
}

const gridItemStyle = {
  width: "100%",
}

export const ProductsPage = () => {
  const { t } = useTranslation()
  const { env } = useNavigator()
  const navigate = useNavigate()
  const { cartItems, setCartItems, foods, groupsList, language } = useContext(CartContext)

  console.log("foods_CartContext :>> ", foods)

  useScrollPositionSaver("products")

  const onAdd = (food) => {
    const exist = cartItems.find((x) => x.id === food.id)
    if (exist) {
      setCartItems(
        cartItems.map((x) => (x.id === food.id ? { ...exist, quantity: exist.quantity + 1 } : x))
      )
    } else {
      setCartItems([...cartItems, { ...food, quantity: 1 }])
    }
  }

  const onRemove = (food) => {
    const exist = cartItems.find((x) => x.id === food.id)
    if (exist.quantity === 1) {
      setCartItems(cartItems.filter((x) => x.id !== food.id))
    } else {
      setCartItems(
        cartItems.map((x) => (x.id === food.id ? { ...exist, quantity: exist.quantity - 1 } : x))
      )
    }
  }

  const onSubmit = useCallback(() => {
    navigate("/order")
  }, [cartItems])

  const flexStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    padding: "16px",
  }

  const flexStyleProducts = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    // padding: "0 16px"
  }

  // Добавляем "Other" как группу в sortedGroupsList
  const otherGroup = {
    id: "other",
    name: t("Other"),
    translations: {},
    order: 999, // Помещаем группу "Other" в конец списка
  }

  // Сортировка групп по полю 'order'
  // const sortedGroupsList = groupsList.sort((a, b) => a.order - b.order)
  const sortedGroupsList = [...groupsList, otherGroup].sort((a, b) => (a.order || 999) - (b.order || 999))

  const groupsById = {}
  sortedGroupsList.forEach((group) => {
    groupsById[group.id] = group
  })

  const foodsMarkupByGroups = {}
  foods.forEach((food) => {
    // const group = food.group_obj?.id || ""
    const group = food.group_obj?.id || "other"

    if (!foodsMarkupByGroups[group]) {
      foodsMarkupByGroups[group] = []
    }

    const foodWithQuantity = cartItems.find((item) => item.id === food.id)

    const quantity = foodWithQuantity ? foodWithQuantity.quantity : 0

    foodsMarkupByGroups[group].push(
      <Box key={food.id} sx={gridItemStyle}>
        <CardColumn food={food} onAdd={onAdd} onRemove={onRemove} quantity={quantity} />
      </Box>
    )
  })

  console.log("foodsMarkupByGroups :>> ", foodsMarkupByGroups)

  const markup = []
  const menuItems = []

  // Использование отсортированного списка для генерации разметки
  sortedGroupsList.forEach((group) => {
    const groupId = group.id
    const title = group.name || "Other"
    const translations = group.translations
    const anchor = groupId ? `section-${groupId}` : "other"

    // Проверяем, есть ли продукты в этой группе
    if (foodsMarkupByGroups[groupId] && foodsMarkupByGroups[groupId].length > 0) {
      markup.push(
        <div key={groupId} style={{ width: "100%" }} data-nav-section={anchor}>
          <div className="anchor" id={anchor} />
          <Box sx={flexStyle}>
            <h3>
              {translations && translations[language]
                ? translations[language].toUpperCase()
                : title.toUpperCase()}
            </h3>
          </Box>
          <Box sx={gridContainerStyle}>{foodsMarkupByGroups[groupId]}</Box>
        </div>
      )

      translations?.[language] || title

      // Добавляем пункт в меню только если есть продукты в этой группе
      menuItems.push({ anchor, content: translations?.[language] || title })
    }
  })

  return (
    <>
      <div
        style={{
          position: "sticky",
          top: "0",
          backgroundColor: "#131415",
          zIndex: "10",
        }}
      >
        <NavHighlightedMenu items={menuItems} offset={60} />
      </div>

      {/* <br /> */}

      <Box sx={flexStyleProducts} className="cartItems">
        {markup}
        {/* {console.log('cartItems >> ', cartItems)} */}
        {cartItems.length !== 0 && env === "browser" && (
          <Footer>
            <BigButton disable={cartItems.length === 0} onClick={onSubmit}>
              {t("Order")}
            </BigButton>{" "}
          </Footer>
        )}
      </Box>
    </>
  )
}
